export default __webpack_public_path__ + "static/media/icon-link.bddf98c8.svg";